import { useTranslation } from 'react-i18next';

import { Dialog, DialogActions } from '@/components/molecules/dialog';
import { useRemoveDestinationGroup } from '@/features/destination-groups/hooks/mutation/use-remove-destination-group';
import { useNavigateBack } from '@/hooks/use-navigate-back';

interface Props extends DialogActions {
  groupId: number;
  groupName: string;
}

const RemoveDestinationGroupDialog = ({ open, onCancel, groupId, groupName }: Props) => {
  const { t } = useTranslation(['destinationGroups']);
  const { navigateBack } = useNavigateBack();

  const onSuccessRemoveDestinationGroup = () => {
    navigateBack('/destination-groups');

    onCancel?.();
  };

  const { mutate: removeDestinationGroup } = useRemoveDestinationGroup(
    onSuccessRemoveDestinationGroup,
  );

  return (
    <Dialog
      open={open}
      onCancel={onCancel}
      onConfirm={() => removeDestinationGroup(groupId)}
      title={t('destinationGroups:dialog.deletingGroup')}
      variant="warning">
      {`${t('destinationGroups:dialog.areYouSure')}: ${groupName}`}
    </Dialog>
  );
};

export default RemoveDestinationGroupDialog;
